// extracted by mini-css-extract-plugin
export var backdropBlur = "_mz-0";
export var contentCard = "_mz-5";
export var frame = "_mz-2";
export var image = "_mz-4";
export var imagePane = "_mz-3";
export var modal = "_mz-1";